import service from '@/utils/server';

const modName='/md/device/';

//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const exportData = data => {
  return service({
    url: modName + 'export',
    method: 'post',
    data
  });
};

export const getDeviceAttribute = data => {
  return service({
    url: modName + 'getDeviceAttribute',
    method: 'post',
    data
  });
};

export const updateDeviceAttributeValue = data => {
  return service({
    url: modName + 'updateDeviceAttributeValue',
    method: 'post',
    data
  });
};

export const operateOpStatus = data => {
  return service({
    url: modName + 'operateOpStatus',
    method: 'post',
    data
  });
};






// WEBPACK FOOTER //
// ./src/page/md/device/api/index.js